// extracted by mini-css-extract-plugin
module.exports = {"label":"CryptoRewardsLoadingStateLabel__label__1GW2W"};